import { render, staticRenderFns } from "./VigneronOnlineCms.vue?vue&type=template&id=321067a0"
import script from "./VigneronOnlineCms.vue?vue&type=script&lang=ts"
export * from "./VigneronOnlineCms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports